import React, { Component } from 'react';
import { eImageTypes } from '../../../../common/utils/fileUploadUtils';

export default class ItemMultiFileIcon extends Component {
  getImageFromFiles(files) {
    let image;
    for (let i = 0; i < files.length; i++) {
      if (eImageTypes.includes(files[i].mimeType)) {
        image = files[i];
      }
    }
    return image ? image : null;
  }
  constructor(props) {
    super(props);
    this.downloadFile = this.props.downloadFile.bind(this);
  }
  render() {
    const { files, item, s3Url } = this.props;
    const image = this.getImageFromFiles(files);
    const file = files && files.length ? files[0] : '';
    return (
      <div className="multi-file-icon-container file-icon-col-flex">
        <a
          className="multi-file-icon-details file-icon-col-flex"
          href={
            file.isPrivate === false
              ? s3Url + (image ? image.key : file ? file.key : '')
              : undefined
          }
          onClick={() =>
            file.isPrivate === true
              ? this.downloadFile(
                  item.uuid,
                  file.uuid,
                  file.collectionName,
                  file.collectionField,
                  file.originalName,
                )
              : ''
          }
        >
          {image ? (
            <div className="multi-file-icon-image-wrapper">
              <img
                src={
                  image.isExternalUrl
                    ? image.url
                    : image.isPrivate === true
                    ? image.smallIcon
                      ? image.smallIcon
                      : 'https://drapcode-static.s3.amazonaws.com/img/placeholder-img.png'
                    : `${s3Url}${image.key}`
                }
                className="multi-file-icon-image"
                onClick={() =>
                  image.isPrivate === true
                    ? this.downloadFile(
                        item.uuid,
                        image.uuid,
                        image.collectionName,
                        image.collectionField,
                        image.originalName,
                      )
                    : undefined
                }
              />
            </div>
          ) : files.length ? (
            <i className="webconnect webconnect-file-alt multi-file-icon-icon"></i>
          ) : (
            ''
          )}
          <p className="multi-file-icon-name">
            {image ? image.originalName : file ? file.originalName : ''}
          </p>
        </a>
        {files.length && files.length > 1 ? (
          <p className="multi-file-icon-remaining-file">{`+${files.length - 1} more files`}</p>
        ) : (
          ''
        )}
      </div>
    );
  }
}
